import React, { useContext } from 'react';
import { SearchList } from '../SearchList/SearchList';
import { useAppSelector } from '../../../../../redux/store.model';
import { getAllStores } from '../../../../../redux/structure/selectors/Stores.selector';
import { isLoadingStructure } from '../../../../../redux/structure/selectors/Structure.selector';
import { useParams } from 'react-router-dom';
import { SearchContext } from '../SearchBar';

export const StoreSearch = () => {
  const { search } = useContext(SearchContext);
  const searchQuery = search.toLowerCase();
  const { marketId } = useParams<{ marketId: string }>();

  const stores = useAppSelector((state) =>
    getAllStores(state, { workspaceId: marketId })
  );
  const isLoading = useAppSelector((state) =>
    isLoadingStructure(state, { workspaceId: marketId })
  );

  const filteredStores =
    stores
      ?.filter((store) => store.name?.toLowerCase().includes(searchQuery))
      .map((item) => {
        return { ...item, key: item.id ?? '', value: item.name ?? '' };
      }) ?? [];

  return (
    <SearchList
      header="initial_setup.store_label"
      list={filteredStores}
      loading={isLoading}
    />
  );
};
